import LoginState, { LoginProps } from "./Login.models";
import './Login.scss';
import AuthenticationService from "../../../services/identity/AuthenticationService";
import axios from "axios";
import StudentService from "../../../services/student/StudentService";
import LoginImage from '../../../assest/images/BarandeSaz_Logo.png';
import { LoginCustomAuthenticatedComponenet } from "../../base/AuthenticatedComponent/AuthenticatedComponent";
import { NavLink } from "react-router-dom";
import NotifyContext from "../../../contexts/NotifyContext";

export default class Login extends LoginCustomAuthenticatedComponenet<LoginProps, LoginState> {
    static contextType = NotifyContext

    authenticationService: AuthenticationService;
    studentService: StudentService;
    constructor(props: any) {
        super(props);
        this.authenticationService = new AuthenticationService();
        this.studentService = new StudentService();
        this.state = { sendOTPCode: false, singInView: { otpCode: '' }, getotpView: { nationalCode: '' } };
    }

    getOTPCode = () => {
        let self = this;
        let scope = self.state;

        if (scope.getotpView.nationalCode !== null && scope.getotpView.nationalCode.length === 10) {
            self.authenticationService.sendOTPByUserName(scope.getotpView.nationalCode).then(function (response) {
                if (response.success)
                    self.setState({ sendOTPCode: true });
            });
        } else {
            self.context.showNotify({ badge: "danger", title: "رخداد خطا", description: "لطفا کد ملی خود را به درستی وارد کنید" })
        }
    }

    signIn = (otp: string) => {
        let self = this;
        let scope = self.state;

        scope.singInView.otpCode = otp;
        if (scope.singInView.otpCode.length === 4) {
            self.authenticationService.signIn({ userName: scope.getotpView.nationalCode, otp: scope.singInView.otpCode }).then(function (response) {
                if (response.success && response.data.authenticated) {
                    let token = response.data.accessToken;
                    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    localStorage.setItem("access_token", JSON.stringify(response.data));
                    window.location.href = "/Dashboard";
                }
                else {
                    self.context.showNotify({ badge: "danger", title: "رخداد خطا", description: "کد وارد شده نادرست می باشد" });
                }
            })
        }
    }

    changeNationalCode = () => {
        let self = this;
        self.setState({ sendOTPCode: false, getotpView: { nationalCode: '' }, singInView: { otpCode: '' } })
    }

    render(): React.ReactNode {

        let content;
        if (this.state.sendOTPCode)
            content = (<>

                <div className="login-title">
                    <label>احراز هویت</label>
                    <span>کدی که دریافت کرده اید را وارد کنید</span>
                </div>
                <div className="login-content mb-5">
                    <input className="form-control" inputMode="numeric" placeholder="کد امنیتی" maxLength={4}
                        value={this.state.singInView.otpCode} onKeyUp={e => this.state.singInView.otpCode.length === 4 ? this.signIn(this.state.singInView.otpCode) : ''} onChange={e => this.setState({ singInView: { otpCode: e.target.value } })}>
                    </input>

                    <a onClick={this.changeNationalCode} className="change-nationalcode">ویرایش کد ملی </a>
                    <a onClick={this.getOTPCode} className="resend-otp">ارسال کد جدید</a>
                </div>
                <button type="submit" onClick={() => this.signIn(this.state.singInView.otpCode)} className="btn btn-block btn-primary">ورود</button>
            </>);
        else
            content = (
                <>
                    <div className="login-title">
                        <label>ورود به سامانه</label>
                        <span>خوش آمدید! برای شروع، کد ملی خود را وارد کنید</span>
                    </div>
                    <input className="form-control" inputMode="numeric" placeholder="کد ملی" value={this.state.getotpView.nationalCode} onChange={e => this.setState({ getotpView: { nationalCode: e.target.value } })}></input>
                    <button type="submit" onClick={() => this.getOTPCode()} className="btn btn-block btn-primary mt-2">ادامه</button>
                    <NavLink to={"/Register"} className="col-12 notspace">
                        <button type="button" className="btn btn-block btn-outline-primary mt-2">ثبت نام</button>
                    </NavLink>
                </>
            );

        return (<>
            <div className="login-custom-area">
                {content}
            </div>
        </>)
    }
}